import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

import {
  DeleteItem,
  EditItem,
  SwapItem,
  CopyStyle,
  isCopyStyleEnabled,
  DuplicateItem,
}
  from './ItemActions';

const ItemActionsBar = ({
  item,
  hasProduct,
  invalid,
  isDiscontinued,
  containerHasMultipleItems,
  canModifyItem,
  isMandi,
}) => {
  if (!(hasProduct || containerHasMultipleItems)) {
    return null;
  }

  const itemId = useMemo(() => get('itemId', item), [item]);

  return (
    <div className="itemActionsBar">
      {canModifyItem && !isDiscontinued ? <EditItem itemId={itemId} /> : null}
      {canModifyItem ? <SwapItem itemId={itemId} /> : null}
      {isCopyStyleEnabled(item) ? <CopyStyle itemId={itemId} /> : null}
      {canModifyItem && !isMandi && !invalid && !isDiscontinued ?
        <DuplicateItem itemId={itemId} /> : null}
      {!isMandi ? <DeleteItem itemId={itemId} /> : null}
    </div>
  );
};

ItemActionsBar.propTypes = {
  item: PropTypes.shape({
    itemId: PropTypes.string.isRequired,
  }).isRequired,
  hasProduct: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  isDiscontinued: PropTypes.bool.isRequired,
  containerHasMultipleItems: PropTypes.bool.isRequired,
  canModifyItem: PropTypes.bool.isRequired,
  isMandi: PropTypes.bool,
};

ItemActionsBar.defaultProps = {
  isMandi: false,
};

export default ItemActionsBar;
